<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">QuickBooks</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <b-row align-v="center" slot="header">
            <b-col>
              <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-0">QuickBooks Integration</h3>
                <b-button variant="danger" @click="deleteTokens" v-if="token">Remove Integration</b-button>
              </div>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <div v-if="token">
            <div v-if="token.access_token_expired">
              <div class="mb-2" v-if="!token.refresh_token_expired"><b-button variant="danger" @click="refreshToken">Refresh QuickBooks Token</b-button></div>
              <div v-else>
                <h3 class="text-danger mb-3">Your QuickBooks Token has expired. Please reconnect to your QuickBooks account.</h3>
                <div class="mb-2">
                  <strong>Step 1:</strong> <b-button variant="danger" href="https://accounts.intuit.com/app/sign-in" target="_blank" @click="disabled = false">Sign Into QuickBooks</b-button>
                </div>
                <div>
                  <strong>Step 2:</strong> <b-button variant="danger" @click="connect" :disabled="disabled">Authorize</b-button>
                </div>
              </div>
            </div>
            <div v-else>
              <h3 class="text-center text-success">Current QuickBooks Token is Valid</h3>
            </div>
          </div>
          <div v-else>
            <div class="mb-2">
              <strong>Step 1:</strong> <b-button variant="danger" href="https://accounts.intuit.com/app/sign-in" target="_blank" @click="disabled = false">Sign Into QuickBooks</b-button>
            </div>
            <div>
              <strong>Step 2:</strong> <b-button variant="danger" @click="connect" :disabled="disabled">Authorize</b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-container>
    <b-modal id="connect-modal" hide-footer hide-header>
      <b-embed
        type="embed"
        aspect="1by1"
        :src="connectLink"
        @closeModal="closeModal"
      ></b-embed>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

export default {
  components: {
    RouteBreadCrumb
  },
  data() {
    return {
      connectLink: null,
      disabled: true,
      installed: true,
      token: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute'
    }),
  },
  methods: {
    async getToken() {
      await axios.get(this.userRoute + "/integrations/quickbooks/token")
      .then(response => {
        this.token = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async connect() {
      await axios.get(this.userRoute + "/integrations/quickbooks")
      .then(response => {
        this.connectLink = response.data;
        this.$bvModal.show('connect-modal');
      })
      .catch(error => {
        // 
      });
    },
    async refreshToken() {
      await axios.get(this.userRoute + "/integrations/quickbooks/token/refresh")
      .then(response => {
        this.token = response.data;
        swal.fire({
          title: `Success`,
          text: 'QuickBooks Token refreshed successfully.',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
      })
      .catch(error => {
        // 
      });
    },
    closeModal() {
      this.$bvModal.hide('connect-modal');
    },
    async deleteTokens() {
      await axios.post(this.userRoute + "/integrations/quickbooks/token/delete")
      .then(response => {
        this.token = null;
        swal.fire({
          title: `Success`,
          text: 'QuickBooks Token deleted successfully.',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
      })
      .catch(error => {
        // 
      });
    }
  },
  created() {
    this.getToken();
  }
};
</script>

<style lang="scss">
#connect-modal {
  .modal-dialog,
  .modal-content {
      height: calc(100% - 30px);
  }

  .modal-body {
      max-height: 100%;
      overflow-y: visible;
  }
}
</style>